/** Normalized flow slug; falsy input → empty string (for exitFlow). Mirrors backend's constants/searchFlowAnalytics.js. */
export const normalizeFlowSlug = (value) => {
  if (value == null || value === "") return "";
  return String(value).trim().toLowerCase();
};

/** Entry flow at session start — defaults to asp when unknown. */
export const normalizeEntryFlowSlug = (value) => normalizeFlowSlug(value) || "asp";
